import numbro from 'numbro';
import React from 'react';
import { animated, useSpring } from 'react-spring';
import cx from 'classnames';

type Props = {
  value: number | undefined | null;
  displayDecimals?: number;
  removeTrailingZeros?: boolean;
  defaultDisplay?: string;
  postfix?: string;
  prefix?: string;
  isLoading?: boolean;
  id?: string;
  useNumbro?: boolean;
  className?: string;
};

// https://github.com/buildo/react-placeholder
// https://skeletonreact.com/
const FormatNumber: React.FC<Props> = (props) => {
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    if (props.isLoading) {
      setShowLoader(true);
    }

    // Show loader a bits longer to avoid loading flash
    if (!props.isLoading && showLoader) {
      setShowLoader(false);
    }
  }, [props.isLoading, showLoader]);

  // Hooks used to fade in/out the loader or the button contents
  const fadeOutProps = useSpring({ opacity: showLoader ? 1 : 0 });
  const fadeInProps = useSpring({ opacity: showLoader ? 0 : 1 });

  const prefix = props.prefix || '';
  const postfix = props.postfix || '';
  if (props.isLoading) {
    return (
      <div className="loadable-small">
        <animated.div style={fadeOutProps}>
          <div className="loader" />
        </animated.div>
      </div>
    );
  }

  if (props.value != null) {
    return (
      <animated.div style={fadeInProps} id={props.id} className={cx(props.className)}>
        {prefix}
        {/* replace() removes trailing zeros */}
        {props.useNumbro ? (
          <span className="cy-number-percent">
            {numbro(props.value).format({
              thousandSeparated: true,
              mantissa: props.value > 0 && props.value < 0.01 ? 4 : 2
            })}
          </span>
        ) : (
          <span className="cy-number-percent">
            {props.value.toFixed(props.displayDecimals || 2).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')}
          </span>
        )}
        {postfix}
      </animated.div>
    );
  }

  if (props.defaultDisplay) {
    return (
      <animated.div style={fadeInProps} className={cx(props.className)}>
        {prefix}
        {props.defaultDisplay}
        {postfix}
      </animated.div>
    );
  }
  return null;
};

export default FormatNumber;
